import { SignInIdentifier } from '@logto/schemas';
import { useTranslation } from 'react-i18next';
import BirdWelcome from '@/ui-assets/images/bird-welcome.webp';
import { formatPhoneNumberWithCountryCallingCode } from '@/utils/country-code';

import styles from './index.module.scss';

export const LinkAccountModalContent = (type: string, value: string) => {
  const { t } = useTranslation();

  return (
    <div>
      <img className={styles.image} src={BirdWelcome} width={225} height={186} alt="" />
      <p className={styles.title}>{t('description.link_account_id_exists_title')}</p>
      <p className={styles.description}>
        {t('description.link_account_id_exists', {
          type: t(`description.${type === SignInIdentifier.Email ? 'email' : 'phone_number'}`),
          value:
            type === SignInIdentifier.Phone
              ? formatPhoneNumberWithCountryCallingCode(value)
              : value,
        })}
      </p>
    </div>
  );
};
